module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-rank_2.png?v=b1edb2a0";